import { i18n, i18nExists } from 'src/i18n';

// The admin-auth endpoints (POST /auth/admin/*) return a machine-readable
// `code` plus optional hints. The backend envelope is not 100% pinned, so we
// read defensively from both the top level and the legacy `{ error: { ... } }`
// wrapper used elsewhere in this app. The deployed backend response is always
// authoritative — extend the lookups here if the shape changes.
export function parseAdminAuthError(error) {
  const status =
    (error && error.response && error.response.status) ||
    null;

  const data =
    (error && error.response && error.response.data) || {};

  const nested = data.error || {};

  const code = data.code || nested.code || null;

  const retryAfterSeconds = firstNumber([
    data.retryAfterSeconds,
    nested.retryAfterSeconds,
    headerNumber(error, 'retry-after'),
  ]);

  // Backend uses `attemptsRemaining`; keep `remainingAttempts` as a fallback.
  const remainingAttempts = firstNumber([
    data.attemptsRemaining,
    nested.attemptsRemaining,
    data.remainingAttempts,
    nested.remainingAttempts,
  ]);

  return {
    status,
    code,
    retryAfterSeconds,
    remainingAttempts,
  };
}

function firstNumber(candidates) {
  for (const value of candidates) {
    const parsed = Number(value);
    if (value != null && !Number.isNaN(parsed)) {
      return parsed;
    }
  }
  return null;
}

function headerNumber(error, name) {
  const headers =
    error && error.response && error.response.headers;
  if (!headers) {
    return null;
  }
  return headers[name];
}

// Maps an admin-auth error `code` to a user-facing message. Unknown / missing
// codes fall back to a generic message so we never leak which factor failed.
export function adminAuthMessage(code) {
  const key = `auth.mfa.errors.${code}`;

  if (code && i18nExists(key)) {
    return i18n(key);
  }

  return i18n('auth.mfa.errors.default');
}
